<template>
    <div>
        <NuxtLayout>
            <template #body_page>
                <div>
                    <SectionHero class="bg-hero mb-100 mb-pt-81 mb-pb-81">
                        <template #title>
                            Experience the world <br class="sp-none"> in extraordinary ways
                        </template>
                        <template #sub-title>
                            Learn more about why you should travel with Designer Journeys
                        </template>
                        <template #button>
                            <router-link
                                :to="{ name: 'trip-gallery' }"
                                class="button button-blue"
                                title="Go to page: Explore Our Gallery"
                                aria-label="Go to page: Explore Our Gallery"
                                @click="setGallerySource"
                            >
                                Explore Our Gallery
                            </router-link>
                        </template>
                    </SectionHero>
                    <div class='container'>
                        <WhoWeAre/>
                        <div class='tc mb-100 mb-mb-60 mb-tl'>
                            <h2 class='fs-36 mb-fs-28 fw-900 mb-30'>Our Team</h2>
                            <p class='fs-16 lh-24 mb-0 maxw-870 dib'>
                                The Designer Journeys team is made up of travel enthusiasts from Australia, New Zealand, Brazil, Vietnam, South Africa, UK, Japan, USA and Poland. We work closely with our expansive network of trusted Local Designers from all over the world to design extraordinary travel experiences for you. <br><br>
                                With decades of travel industry experience between us, as well as a commitment to delivering unique travel experiences that you won't find anywhere else, you can rest assured that your trip is in the best hands.
                            </p>
                        </div>
                        <LocalDesigners/>
                    </div>
                    <Reviews :listReviews = listReviews class='pt-220 pb-120 mb-pt-160 mb-pb-10 mb-100 mb-mb-60'>
                        <template #title>
                            What Our Travellers Love About Us
                        </template>
                        <template #sub-title>
                            Don't just take our word for it. Read what other travellers love about designing their trip with Designer Journeys!
                        </template>
                    </Reviews>
                    <Explore heap-source="about-us-section-explore"/>
                </div>
            </template>
        </NuxtLayout>
    </div>
</template>

<script>
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import SectionHero from '~/components/sections/SectionHero/SectionHero'
import WhoWeAre from '~/components/pages/AboutUs/sections/WhoWeAre'
import LocalDesigners from '~/components/pages/AboutUs/sections/LocalDesigners'
import Explore from '~/components/pages/AboutUs/sections/Explore'
import Reviews from '~/components/sections/SectionReview/Reviews'
import Metadata from '~/assets/meta_data.json'
// import { useHead } from '@vueuse/head'
import {onMounted, ref } from 'vue'
import { useHeapStore } from '~/store/pinia/heap'

export default {
    name: 'About',
    components: {
        Reviews,
        // DefaultLayout,
        LocalDesigners,
        WhoWeAre,
        Explore,
        SectionHero
    },
    setup() {
        // const route = useRoute()
        // const runtime = useRuntimeConfig()
        const metaData = ref(Metadata);
        const listReviews = [
            {avatar: 'https://s3-cdn.designerjourneys.com/static/images/general/Justin.jpg', author: 'Justin K.', content:'It is great having local people who are able to tailor a trip to my individual needs. I love that I can chat to my consultant to make changes. The turnaround times from my brief were excellent.' },
            {avatar: 'https://s3-cdn.designerjourneys.com/static/images/general/Kat.jpg', author: 'Kat F.', content:'Prompt and knowledgable of many areas and things to do. We felt like our requests were heard and they went above and beyond to provide a mixture of plans for our budget.' },
            {avatar: 'https://s3-cdn.designerjourneys.com/static/images/general/Hannah.jpg', author: 'Hannah J.', content:'Sangita was amazing. She was always available by phone if needed and we felt no hesitation to be in contact. She listened to exactly what we asked for and got it right. All the people we met that worked with her were very trustworthy and honest. I would recommend her and all the people she works with. It was a very personal and well managed trip.' },
            {avatar: 'https://s3-cdn.designerjourneys.com/static/images/general/Dario.jpg', author: 'Dario I.', content:'I just want to thank Georgia and Catlin and all the team for giving us such a great holiday. This was my first holiday in 8 years and I can say it was one of the best. Really appreciate everything you did for us, and will definitely be using them again for our next holiday.' },
            {avatar: 'https://s3-cdn.designerjourneys.com/static/images/general/Benno.jpg', author: 'Benno.', content:'Local agent with local support. It was brilliant to have a local arrange my family trip to Greece. The best bit was having someone on the ground in real time to answer questions once we arrived.' },
        ];
        const heapStore = useHeapStore()

        const setGallerySource = async () => {
            await heapStore.changeGalleryHeap("about-us-hero-section")
        }
        onMounted(() => {
          debounceAmplitudeScriptTracking("View About Us")
        })

        // useHead({
        //     title: computed(() => {
        //         const title = metaData.value.about_us.title
        //         return title
        //     }),

        //     meta: computed(() => {
        //         const title = metaData.value.about_us.title
        //         const description = metaData.value.about_us.description
        //         return [
        //             {
        //                 name: `title`,
        //                 content: title,
        //             },
        //             {
        //                 name: `description`,
        //                 content: description,
        //             }
        //         ]
        //     }),
        //     link: computed(() => {
        //         return [
        //             { rel: 'canonical', href: `${runtime.public.publicDomain}${route.fullPath}`, hreflang: 'en'}
        //         ]
        //     }),
        // })

        return {listReviews, metaData, setGallerySource}
    }
}
</script>
<style scoped lang='scss'>
:deep(.slide .inner-wrapper .next-prev-button) {
    top: 336px;
    @include phone {
        top:0;
    }
}
.bg-hero {
    background:  url('https://s3-cdn.designerjourneys.com/static/images/aboutus/img-banner.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
}
</style>
